import { createContext } from "react";
import { useSelector } from "react-redux";

import {
	AI_VIDEO_GENERATORS,
	ESTATE_PLANNING,
	PARENTAL_CONTROL_APPS,
	PAYROLL_SERVICES,
} from "../../../config/site/features";
import { AppProviders } from "../../components/UIComponents/AppProviders";
import { BaseCompanyList } from "../../components/UIComponents/BaseCompanyList";
import { getVertical } from "../../selectors";
import { styles } from "./verticals/pageLayoutStyles";
import { ProjectManagementCompany } from "./verticals/ProjectManagementCompany";

export const FeaturesVerticalContext = createContext();

const FEATURES_VERTICAL_CONFIG = {
	[PAYROLL_SERVICES]: {
		visitText: "Visit Site",
	},
	[AI_VIDEO_GENERATORS]: {
		visitText: "Try it free",
	},
	[ESTATE_PLANNING]: {
		visitText: "View Deal",
	},
	[PARENTAL_CONTROL_APPS]: {
		visitText: "Try Now",
	},
	DEFAULT: {
		visitText: "Try For Free",
	},
};

const FeaturesCompany = () => {
	const vertical = useSelector(getVertical);

	return (
		<FeaturesVerticalContext.Provider
			value={{
				...FEATURES_VERTICAL_CONFIG["DEFAULT"],
				...FEATURES_VERTICAL_CONFIG?.[vertical],
			}}
		>
			<ProjectManagementCompany />
		</FeaturesVerticalContext.Provider>
	);
};

export const App = () => (
	<AppProviders>
		<BaseCompanyList styles={styles}>
			<FeaturesCompany />
		</BaseCompanyList>
	</AppProviders>
);
